import { ApiGatewayPathBuilder, CloudRunPathBuilder, Env, ICandidateEnvironment, ServiceNames } from 'shared-lib'

const CANDIDATE_BASE_URL = 'https://qa-network.cnected.com'

const env: Env = 'qa'
const projectNumber = '148414587373'
const pathBuilder = new ApiGatewayPathBuilder(env)
const cloudRunPathBuilder = new CloudRunPathBuilder('bx5ylytnlq')

const singleBackendServices: ServiceNames[] = []

export const environment: ICandidateEnvironment = {
  production: false,
  env,
  singleBackendServices,
  firebaseConfig: {
    apiKey: 'AIzaSyBxgYkpbTWg3Tf0roc8Ec2bbquWN7lImPc',
    authDomain: 'cnect-qa-100.firebaseapp.com',
    projectId: 'cnect-qa-100',
    storageBucket: 'qa-content.cnected.com',
    messagingSenderId: projectNumber,
    appId: '1:148414587373:web:d40867c567bbb20e8ec7e4',
    databaseURL: 'https://cnect-qa-100.firebaseio.com',
    measurementId: 'G-H829X2MPN8',
  },
  services: {
    cloudFunctions: 'https://us-central1-cnect-qa-100.cloudfunctions.net',
    applicationHistory: pathBuilder.build('applicationHistory'),
    auth: pathBuilder.build('auth'),
    candidate: pathBuilder.build('candidate'),
    content: pathBuilder.build('content'),
    employer: pathBuilder.build('employer'),
    events: pathBuilder.build('events'),
    jobs: pathBuilder.build('jobs'),
    jobsAutomation: pathBuilder.build('jobsAutomation'),
    registration: pathBuilder.build('registration'),
    files: pathBuilder.build('files'),
    messaging: pathBuilder.build('messaging'),
    community: pathBuilder.build('community'),
    virtualDialogue: pathBuilder.build('virtualDialogue'),
    access: pathBuilder.build('access'),
    social: pathBuilder.build('social'),
    notifications: pathBuilder.build('notifications'),
    user: pathBuilder.build('user'),
    sse: cloudRunPathBuilder.build('sse', false),
    product: pathBuilder.build('product'),
    integration: pathBuilder.build('integration'),
  },
  // We can turn authentication off in case we are using this application inside and SDK and do not want to have any authentication
  authentication: false,
  themesEnabled: true,
  v2ReCaptcha: '6Lc2pOQcAAAAAI_oy89EVGVynt11riErd494oSOd',
  tenantId: 'B2C-USER-ut8uc',
  cdnCname: 'qa-content.cnected.com',
  basePlatformHost: 'qa-network.cnected.com',
  algoliaAppId: 'XSN9B9X19Y',
  employerEmailActionRoute: 'http://qa-employer.cnected.com/#/auth/actions',
  candidateEmailSuccessRoute: 'https://qa-network.cnected.com/#/auth/action-success/verifyEmail',
  passwordRecoveryEmailTemplateId: 'GQKsG5Wnv9sWJ9uY3aDf',
  emailVerificationEmailTemplateId: 'cwdpiIuZAP8dPQqB5s5K',
  betaMessageId: '1HV5MRdznzPO0ivgBbom',
  version: '16ec660',
  candidateBaseUrl: CANDIDATE_BASE_URL,
  careersPageBaseLink: 'https://qa-careers.cnected.com/',
  appDownloadDynamicLink: 'https://cnect.page.link/uEsh',
  tenant: {
    appConfigBaseURL: 'https://qa-content.cnected.com/assets/bootstrap',
    defaultTenant: 'qa-network.cnected.com',
  },
  smartBannerOptions: {
    appIcon: 'https://play-lh.googleusercontent.com/W170UOarQtwNy4GY1JXosU6SD3LBY5OzTYOWsRUL9W6yXYwPoCeUVGeTtuO850ByjSw=w480-h960-rw',
    appStoreUrl: 'https://apps.apple.com/us/app/cnected/id6467040985',
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.e11.prod.cnect',
    ttl: `${24 * 3.6e6}`,
  },
}
